import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tab } from 'src/app/_models/tab';


@Component({
  selector: 'sketch-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {

  @Input() tabs: Tab[] = []; 
  @Output() onSelect = new EventEmitter<Tab>(); 


  selectTab( evt: any, tab: Tab ){
    evt.preventDefault(); 
    this.onSelect.emit( tab );
  }
}
